import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './lang/i18n.js'
import VueSocketIO from 'vue-socket.io'
import VueNoty from 'vuejs-noty'

Vue.use(VueNoty)

Vue.use(new VueSocketIO({
  debug: true,
  connection: '//',
  options: { path: "/api/socket/io/socket.io" }
}))

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
